package com.eladfinish.bible.contest.screens.chapterComplete.features.createCompletions

import com.eladfinish.bible.contest.constants.StringConstants.COLON_SPLITTER
import com.eladfinish.bible.contest.constants.StringConstants.MAKAF
import com.eladfinish.bible.contest.constants.StringConstants.PASEQ
import com.eladfinish.bible.contest.constants.StringConstants.Regex.WHITESPACE
import com.eladfinish.bible.contest.constants.StringConstants.Regex.WORD_CHAR_BOUNDARY
import com.eladfinish.bible.contest.screens.chapterComplete.model.UserCompletionsModel
import kotlinx.collections.immutable.toImmutableList

class BuildUserCompletionsModelUseCase {

    operator fun invoke(chapterText: String): UserCompletionsModel {

        // WORD_CHAR_BOUNDARY rather than \b: JS RegExp's \b is ASCII-only (see WORD_CHAR).
        // WHITESPACE rather than \s: iOS's \s doesn't match NBSP (see WHITESPACE).
        val regex = "[^$WHITESPACE$MAKAF]+$WORD_CHAR_BOUNDARY|$COLON_SPLITTER|$MAKAF".toRegex()

        val tokens = regex.findAll(chapterText)
            .map { match ->
                val word = match.value

                val special = listOf(COLON_SPLITTER, PASEQ.toString(), MAKAF.toString())

                val toggleable =
                    !isOtPasuk(word)
                            && !special.contains(word)

                UserCompletionsModel.Token(
                    raw = word,
                    isToggleable = toggleable,
                )
            }
            .toImmutableList()

        val visibility = List(tokens.size) { true }.toImmutableList()

        return UserCompletionsModel(
            tokens = tokens,
            visibility = visibility,
        )
    }

    private fun isOtPasuk(word: String): Boolean {
        return word.matches(Regex(pattern = "^[א-ת]{1,3}$"))
    }

}
